export default "__VITE_ASSET__CKdufpWD__"